<template>
<modal
    @close="closeModal"
    v-model:show="modal.open"
    modal-classes="modal-forum"
>
    <transition name="transition">
        <class-loading v-if="loading" expand/>
    </transition>
    <div class="menu">
        <span @click="changeModal('description')">{{$t('class.description')}}</span>
        <span @click="changeModal('forum')">{{$t('class.forum')}}</span>
    </div>
    <div class="content">
        <transition v-if="modal.tab === 'description'" name="transition">
            <div v-html="modal.description"/>
        </transition>
        <transition v-else-if="!loading" name="transition">
            <forum v-if="forum" noloading :name="modal.name" :forum="forum"/>
            <div v-else>
                <span>{{$t('class.hasnt_forum')}}</span>
            </div>
        </transition>
    </div>
</modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ClassLoading from './ClassLoading';
import Modal from '../../argon/components/Modal';
import Forum from '../Forum';


export default {
    name: 'ClassInfoModal',

    components: {
        Modal,
        Forum,
        ClassLoading,
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: mapGetters({
        modal: 'CLASS_MODAL',
        forum: 'CLASS_FORUM',
    }),

    methods: {
        ...mapMutations({
            setModal: 'SET_CLASS_MODAL',
            setForum: 'SET_CLASS_FORUM',
        }),

        ...mapActions({
            loadForum: 'CLASS_LOAD_FORUM',
        }),

        changeModal(tab) {
            this.setModal({ ...this.modal, tab });
            if (tab === 'forum' && !this.forum) {
                this.getForum();
            }
        },

        async getForum() {
            this.loading = true;
            await this.loadForum();
            this.loading = false;
        },

        closeModal() {
            this.setModal({ ...this.modal, open: false, description: '' });
            this.setForum(null);
        },
    },
};
</script>

<style lang="sass">
.modal-forum
    width: 80vw
    max-width: 900px !important
    .modal-body
        height: 75vh
        overflow-y: auto
</style>
<style lang="sass" scoped>
.menu
    display: flex
    margin-bottom: 24px
    span
        width: 50%
        font-weight: bold
        text-align: center
        cursor: pointer
.transition-enter-active, .transition-leave-active
  transition: opacity .5s

.transition-enter, .transition-leave-to
  opacity: 0

</style>
